import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import OrganizationService from "../../../../../services/HRM/OrganizationService";
import BaseService from "../../../../../services/BaseService";
import Loader from "../../../../common/Loader";
import "../style.scss";

const emptyEntry = () => ({ name: "", attachmentUrl: "", loading: false });

const AddOrganization = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const lang = useSelector((state) => state.auth?.lang);
	const [id, setId] = useState(null);
	const [view, setView] = useState(false);
	const [loading, setLoading] = useState(false);
	const [formData, setFormData] = useState({
		name: "",
		additionalNames: [emptyEntry()],
	});

	useEffect(() => {
		const isEdit = location?.pathname.includes("edit");
		const isView = location?.pathname.includes("view");
		if (isEdit || isView) {
			const item = location.state;
			setId(item?.id);
			setFormData({
				name: item?.name || "",
				additionalNames: item?.additionalNames?.length
					? item.additionalNames.map((an) => ({
							name: an.name || "",
							attachmentUrl: an.attachmentUrl || "",
							loading: false,
						}))
					: [emptyEntry()],
			});
		}
		if (isView) setView(true);
	}, [location]);

	const updateEntry = (index, field, value) => {
		setFormData((prev) => ({
			...prev,
			additionalNames: prev.additionalNames.map((entry, i) =>
				i === index ? { ...entry, [field]: value } : entry,
			),
		}));
	};

	const fileHandler = (e, index) => {
		const file = e.target.files[0];
		if (!file) return;
		updateEntry(index, "loading", true);
		new BaseService().postUpload(file).then((res) => {
			if (res?.status === 200) {
				setFormData((prev) => ({
					...prev,
					additionalNames: prev.additionalNames.map((entry, i) =>
						i === index
							? { ...entry, attachmentUrl: res?.data?.url, loading: false }
							: entry,
					),
				}));
			} else {
				updateEntry(index, "loading", false);
			}
		});
	};

	const onSubmit = (e) => {
		e.preventDefault();
		const data = {
			name: formData.name,
			additionalNames: formData.additionalNames.map(
				({ name, attachmentUrl }) => ({
					name,
					attachmentUrl: attachmentUrl || null,
				}),
			),
		};
		setLoading(true);
		const organizationService = new OrganizationService();
		const req = id
			? organizationService.update(id, data)
			: organizationService.create(data);
		req
			.then((res) => {
				if (res?.status === 200 || res?.status === 201) {
					toast.success(
						id
							? Translate[lang]?.updated_successfully
							: Translate[lang]?.added_successfully || "Added Successfully",
					);
					navigate("/organization");
				}
			})
			.finally(() => setLoading(false));
	};

	return (
		<Card className="p-4 add-organization">
			<AvForm onValidSubmit={onSubmit}>
				<Row>
					<Col lg={6} className="mb-3">
						<AvField
							label={Translate[lang]?.name}
							name="name"
							type="text"
							disabled={view}
							value={formData.name}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang]?.field_required,
								},
							}}
							placeholder={Translate[lang]?.name}
							onChange={(e) =>
								setFormData({ ...formData, name: e.target.value })
							}
						/>
					</Col>
					<Col md={12}>
						<label className="text-label">
							{Translate[lang]?.additional_names || "Additional Names"}
						</label>
					</Col>

					{formData.additionalNames.map((entry, index) => (
						<React.Fragment key={index}>
							<Col md={6} className="mb-3">
								<AvField
									label={`${index + 1}) ${Translate[lang]?.name}`}
									name={`addName${index}`}
									type="text"
									disabled={view}
									value={entry.name}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang]?.field_required,
										},
									}}
									placeholder={Translate[lang]?.name}
									onChange={(e) => updateEntry(index, "name", e.target.value)}
								/>
							</Col>
							<Col md={3} className="mb-3">
								<div className="form-group w-100">
									<div className="image-placeholder">
										{!view && (
											<div className="avatar-edit">
												<input
													type="file"
													onChange={(e) => fileHandler(e, index)}
													id={`imgUpload${index}`}
												/>
												<label htmlFor={`imgUpload${index}`} />
											</div>
										)}
										<div className="avatar-preview2 m-auto">
											<div>
												{!entry.loading && !entry.attachmentUrl && (
													<i
														className="la la-cloud-upload-alt"
														style={{ fontSize: "4rem", color: "#aaa" }}
													/>
												)}
												{entry.attachmentUrl && !entry.loading && (
													<div
														className="h-100"
														style={{ position: "relative" }}>
														{!view && (
															<i
																className="la la-trash text-danger"
																style={{
																	position: "absolute",
																	zIndex: 2,
																	top: 0,
																	left: 0,
																	border: "1px solid #ff4847",
																	borderRadius: "50%",
																	padding: "4px",
																	fontSize: "20px",
																	background: "#fff",
																	cursor: "pointer",
																}}
																onClick={() =>
																	updateEntry(index, "attachmentUrl", "")
																}
															/>
														)}
														<a
															href={entry.attachmentUrl}
															target="_blank"
															rel="noreferrer">
															{entry.attachmentUrl.includes("pdf") ? (
																<i
																	className="la la-file-pdf"
																	style={{ fontSize: "6rem" }}
																/>
															) : (
																<img
																	src={entry.attachmentUrl}
																	alt={index}
																	className="w-100 h-100"
																/>
															)}
														</a>
													</div>
												)}
												{entry.loading && <Loader />}
											</div>
										</div>
									</div>
								</div>
							</Col>
							<Col md={3} className="mb-3 d-flex align-items-start mt-3">
								{!view && formData.additionalNames.length > 1 && (
									<Button
										variant="outline-danger"
										size="sm"
										type="button"
										onClick={() =>
											setFormData((prev) => ({
												...prev,
												additionalNames: prev.additionalNames.filter(
													(_, i) => i !== index,
												),
											}))
										}>
										<i className="la la-trash" />
									</Button>
								)}
							</Col>
						</React.Fragment>
					))}
				</Row>

				{!view && (
					<div className="d-flex mt-3">
						<Button
							variant="outline-primary"
							type="button"
							onClick={() =>
								setFormData((prev) => ({
									...prev,
									additionalNames: [...prev.additionalNames, emptyEntry()],
								}))
							}>
							{Translate[lang]?.add_new_value}
						</Button>
					</div>
				)}

				<div className="d-flex justify-content-between mt-5">
					<Button
						variant="secondary"
						type="button"
						onClick={() => navigate("/organization")}>
						{Translate[lang]?.cancel}
					</Button>
					{!view && (
						<Button variant="primary" type="submit" disabled={loading}>
							{Translate[lang]?.submit}
						</Button>
					)}
				</div>
			</AvForm>
		</Card>
	);
};

export default AddOrganization;
